import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import {
  CloudOffIcon,
  SearchIcon,
  DownloadIcon,
} from "../../../Resources/Icons/icons";
import {
  GetPolicyChequeReport,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Divider, Stack, Badge } from "@mui/material";
import TabFilter from "../../Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import filterr from "../../../Resources/Images/filter-lines.png";
import exportt from "../../../Resources/Images/export.png";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";

const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const TodayDate = new Date();
const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "User Name",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyType",
    placeMent: true,
    disablePadding: false,
    label: "Policy Type",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Registeration No",
  },
  {
    id: "odStartDate",
    placeMent: true,
    disablePadding: false,
    label: "Od Start Date",
  },
  {
    id: "tpStartDate",
    placeMent: true,
    disablePadding: false,
    label: "TP start Date",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code",
  },
  {
    id: "subBookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Sub Booking Code",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  {
    id: "chequeStatus",
    placeMent: true,
    disablePadding: false,
    label: "Cheque Status",
  },
  {
    id: "chequeNumber",
    placeMent: true,
    disablePadding: false,
    label: "Cheque Number",
  },
  {
    id: "chequeDate",
    placeMent: true,
    disablePadding: false,
    label: "Cheque Date",
  },
  {
    id: "bank",
    placeMent: false,
    disablePadding: false,
    label: "Bank",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const PolicyChequeReport = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [tableData, setTableData] = React.useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(dayjs(Last7Days));
  const [selectedEndDate, setSelectedEndDate] = useState(dayjs(TodayDate));
  const [tableConfig, setTableConfig] = useState({
    isDelete: true,
    isSearch: true,
    isApprove: true,
  });
  const [originalData, setOriginalData] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(tableData), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, tableData]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getTableData = async () => {
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }
    let reqBody = {
      selectedStartDate: selectedStartDate,
      selectedEndDate: endDate,
    };
    GetPolicyChequeReport(reqBody).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          policyDate: e.policyDate
            ? moment(e.policyDate).format("DD/MM/YYYY")
            : "N/A",
          odStartDate: e.odStartDate
            ? moment(e.odStartDate).format("DD/MM/YYYY")
            : "N/A",
          tpStartDate: e.tpStartDate
            ? moment(e.tpStartDate).format("DD/MM/YYYY")
            : "N/A",
          chequeDate: e.chequeDate
            ? moment(e.chequeDate).format("DD/MM/YYYY")
            : "N/A",
        };
      });
      setTableData(data);
      setOriginalData(data);
      setPage(0);
    });
  };

  React.useEffect(() => {
    getTableData();
  }, []);

  const onSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    if (searchTerm === "") {
      setTableData(originalData);
    } else {
      const filteredData = originalData.filter((item) => {
        return Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(searchTerm)
        );
      });
      setTableData(filteredData);
    }

    setPage(0);
  };

  const header = [
    { label: "Policy Date", key: "PolicyDate" },
    { label: "OD Start Date", key: "OdStartDate" },
    { label: "TP Start Date", key: "TpStartDate" },
    { label: "Cheque Date", key: "ChequeDate" },
    { label: "User Name", key: "userName" },
    { label: "Policy Type", key: "policyType" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Registeration Number", key: "registrationNumber" },
    { label: "Booking Code", key: "bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCode" },
    { label: "Total Premium", key: "totalPremium" },
    { label: "Payment Mode", key: "Cheque" },
    { label: "Cheque Status", key: "chequeStatus" },
    { label: "Cheque Number", key: "chequeNumber" },
    { label: "Bank", key: "bank" },
  ];
  const csvFile = {
    filename: "Cheque Report Data",
    headers: header,
    data: tableData,
  };

  const filterBoxData = [
    {
      id: 3,
      label: "Date Range",
      setDate: (e) => {
        setDateRange(e);
        setSelectedStartDate(e ? e[0] : null);
        setSelectedEndDate(e ? e[1] : null);
      },
      type: "noDefaultDate",
      defaultValue: [dayjs().subtract(7, "day"), dayjs()],
    },
  ];

  const handleClearAllState = () => {
    setDateRange(null);
    setSelectedStartDate(dayjs(Last7Days));
    setSelectedEndDate(dayjs(TodayDate));
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 3) {
      setDateRange(null);
      setSelectedStartDate(dayjs(Last7Days));
      setSelectedEndDate(dayjs(TodayDate));
    }
  };

  const handleSaveAllFilter = () => {
    getTableData();
  };

  const activeFiltersCount = dateRange?.[0] ? 1 : 0;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Cheque Report
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        fullWidth
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"flex-end"}
                margin={1}
              >
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={tableData}
                columns={headCells}
              />
            </Grid>
          </Box>
        </Box>
      </div>
    </>
  );
};
export default PolicyChequeReport;
